import { render } from "./VenueParticipants.vue?vue&type=template&id=2978399e"
import script from "./VenueParticipants.js?vue&type=script&lang=js"
export * from "./VenueParticipants.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__